<h2 mat-dialog-title>{{ data.survey.question }}</h2>
<div mat-dialog-content>
  @if (data.survey.isSelect) {
    <div fxLayout="row">
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-select [formControl]="select">
          @for (answer of answers; track answer) {
            <mat-option [value]="answer">{{ answer }}</mat-option>
          }
          @if (data.survey.hasOther) {
            <mat-option value="OTHER">Other</mat-option>
          }
        </mat-select>
        @if (select.errors && select.errors['required']) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (!data.survey.isSelect || (data.survey.isSelect && select.value === 'OTHER')) {
    <div fxLayout="row">
      <mat-form-field appearance="outline" fxFlex="100">
        <textarea matInput rows="5" type="text" [formControl]="text"></textarea>
        @if (text.errors && text.errors['required']) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </div>
  }
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button class="primary-btn filled-btn" (click)="skip()" cdkFocusInitial>Cancel</button>
    <button class="primary-btn filled-btn" (click)="submit()" cdkFocusInitial>Confirm</button>
  </div>
</div>
